<template>
    <v-btn @click="change" :class="`${routeLink}_color`"
        class="text-black !absolute right-0 top-9 !rounded-l-3xl  !w-52 !py-6 !text-center !text-md font-Handel !shadow-lg   !border-r-0 z-50 !capitalize !border-1 hover:!border-black">
        Profile of the month
    </v-btn>
</template>
<script>
export default {
    methods: {
        change() {
            this.$store.dispatch("changePom" , true)
            
        }
    }
}
</script>

<style scoped>
.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(345deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%);
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(353deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%);
}
</style>